import { action, observable } from 'mobx'
import { LayoutRepository } from './LayoutRepository'
import { ControllerStoreBase } from 'src/controllers/ControllerStoreBase'
import { JtechMessage } from 'src/plugins/system.messages'

export class LayoutController extends ControllerStoreBase {
    @observable modules = []
    @observable chartColors = []

    static getInstance () {
      return super.construct(new LayoutController())
    }

    @action setChartColor (colors) {
      this.chartColors = colors
    }

    @action getChartColor () {
      return this.chartColors
    }

    @action async fetchModules () {
      this.modules = await LayoutRepository.findModules()
    }

    @action async reloadConfigurations () {
      await LayoutRepository.reloadConfigurations()
      JtechMessage.success(JtechMessage.getText('CONFIGURATION_UPDATED'))
    }

    getName () {
      return 'LayoutController'
    }
}
